import React from "react"
import UIContext from "@/context/ui-context"

import { AjaxServiceProps, HistoryProps } from "@/context/ui-context"

import { UIState } from "@/context/ui-context"

type CommonProps = AjaxServiceProps & HistoryProps

export interface Message {
    text: string
    persist?: boolean
}

const MessageHandler = (
    props: React.PropsWithChildren<CommonProps>
): JSX.Element => {
    const initialState: UIState = {
        isLoading: false,
        messagesCount: 0,
        successMessages: [],
        infoMessages: [],
        warningMessages: [],
        dangerMessages: []
    }

    const [ui, setUi] = React.useState(initialState)

    React.useEffect(() => {
        const unsubscribeFromStore = props.history.listen(() => {
            clearMessages()
        })

        return () => {
            unsubscribeFromStore()
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    const setLoading = (loading: boolean): void => {
        setUi({ ...ui, isLoading: loading })
    }

    const messagesCount = (): number => {
        return (
            ui.successMessages.length +
            ui.infoMessages.length +
            ui.warningMessages.length +
            ui.dangerMessages.length
        )
    }

    const addSuccessMessage = (message: Message): void => {
        setUi({
            ...ui,
            successMessages: ui.successMessages.concat(message),
            messagesCount: ui.messagesCount + 1
        })
    }

    const addInfoMessage = (message: Message): void => {
        setUi({
            ...ui,
            infoMessages: ui.infoMessages.concat(message),
            messagesCount: ui.messagesCount + 1
        })
    }

    const addWarningMessage = (message: Message): void => {
        setUi({
            ...ui,
            warningMessages: ui.warningMessages.concat(message),
            messagesCount: ui.messagesCount + 1
        })
    }

    const addDangerMessage = (message: Message): void => {
        setUi({
            ...ui,
            dangerMessages: ui.dangerMessages.concat(message),
            messagesCount: ui.messagesCount + 1
        })
    }

    const clearMessages = (): void => {
        const successMessages = ui.successMessages.filter(
            (elem) => elem.persist
        )
        const infoMessages = ui.infoMessages.filter((elem) => elem.persist)
        const warningMessages = ui.warningMessages.filter(
            (elem) => elem.persist
        )
        const dangerMessages = ui.dangerMessages.filter((elem) => elem.persist)

        setUi({
            ...ui,
            successMessages: successMessages,
            infoMessages: infoMessages,
            warningMessages: warningMessages,
            dangerMessages: dangerMessages,
            messagesCount: messagesCount()
        })
    }

    const state = Object.assign(ui, {
        setLoading: setLoading,
        messagesCount: ui.messagesCount,
        addSuccessMessage: addSuccessMessage,
        addInfoMessage: addInfoMessage,
        addWarningMessage: addWarningMessage,
        addDangerMessage: addDangerMessage,
        clearMessages: clearMessages,
        service: props.service,
        history: props.history
    })

    return (
        <UIContext.Provider value={state}>{props.children}</UIContext.Provider>
    )
}

export default MessageHandler
